export const ListaGestionGuialStyles = {
    'root':{
        // width: '340px',
        //background: '#F5F5F6'
    },

    'dropdown': {
        /*position: 'relative' as 'relative',
        //display: 'inline-block',*/
        padding : '0px 0px 0px 0px',
    },

    'dropdownContent': {
        position: 'absolute' as 'absolute',
        backgroundColor: '#f1f1f1',
        minWidth: '210px',
        boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
        textAlign: 'right' as 'right',
        zIndex: 1,
        display: 'block',
        left: 'auto !important',
        right: '0 !important',
        padding : '0px 0px 0px 0px',
        borderRadius: '0px 0px 10px 10px'
    },

    'ul':{
        textAlign: 'right' as 'right',
        padding : '0px 0px 0px 0px',
        marginBottom: '0px',
        marginTop: '0px',
        marginLeft: '0px'
    },

    'li':{
        padding: '10px',
        marginLeft: '0px',
        listStyle:'none',
        '&:hover':{
            backgroundColor : '#eae8e8',
            borderBottomStyle: 'solid' as 'solid',
            borderBottomColor: '#e2dddd'
        }
    },

    'modal': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 1,
    },
    'paper': {
        //display:'flex',
        backgroundColor: '#F5F5F6',
        borderRadius: '0px 0px 15px 15px',
        boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
        width: '100%',
        maxWidth: 'none',
        //minWidth: 370,
        //border: '2px solid #000',
        //boxShadow: theme.shadows[5],
        //padding: theme.spacing(2, 4, 3),
    },

    'headertitulo': {
        //fontWeight: 'bold' as 'bold',
        fontSize: '20px',
        color: 'black',
    },

    'titulo':{
        color: 'black',
        fontSize: '16px',
        paddingBottom: '2px',
        paddingTop: '2px',
        textDecoration: 'underline',
    },

    'detalle':{
        fontSize:'13px',
        color: '#232121',
        //fontWeight: 'bold' as 'bold',

    },

    'datos':{
        color: '#827e7e',
    },

    'repartidor':{
        fontSize:'0.9rem',
        color: '#827e7e'
    },

    'iconpadding':{
        padding:'0px 0px 20px 28px'
    }


}